import classNames from 'classnames'
import { VertSpacerXS } from '../layout'

interface IProps {
  text?: string
  classes?: string
  children?: React.ReactNode
}

export const NoResultsCard: React.FC<IProps> = ({ text, classes, children }) => (
  <div
    className={classNames(
      classes,
      'relative overflow-hidden bg-surface text-text border border-border rounded-[30px] px-6 py-4 full flex flex-col items-start justify-start'
    )}
  >
    <div className='flex items-center justify-center jost-medium'>{text || 'Nothing to show here.'}</div>
    <VertSpacerXS />
    {children && <div className='jost-light text-[0.9em]'>{children}</div>}
  </div>
)
